"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecentlyViewedLinks = function RecentlyViewedLinks() {
  return _react2.default.createElement(
    "div",
    { className: "spacer" },
    _react2.default.createElement(
      "div",
      { className: "sidecontentbox" },
      _react2.default.createElement(
        "div",
        { className: "title" },
        _react2.default.createElement(
          "h1",
          null,
          "RECENTLY VIEWED LINKS"
        )
      ),
      _react2.default.createElement(
        "ul",
        { className: "content" },
        _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement(
            "div",
            { className: "gadget" },
            _react2.default.createElement(
              "div",
              { className: "click-gadget" },
              _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "div",
                  { className: "reddit-link even first-half thing id-t5_m" },
                  _react2.default.createElement(
                    "div",
                    { className: "midcol unvoted" },
                    _react2.default.createElement("div", {
                      "aria-label": "upvote",
                      className: "arrow up login-required access-required",
                      "data-event-action": "upvote",
                      role: "button",
                      tabIndex: 0
                    }),
                    _react2.default.createElement("div", {
                      "aria-label": "downvote",
                      className: "arrow down login-required access-required",
                      "data-event-action": "downvote",
                      role: "button",
                      tabIndex: 0
                    })
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: "reddit-entry entry unvoted" },
                    _react2.default.createElement(
                      "a",
                      {
                        className: "reddit-link-title may-blank"
                      },
                      "NOT SUPPORTED YET"
                    ),
                    _react2.default.createElement("br", null),
                    _react2.default.createElement(
                      "small",
                      null,
                      _react2.default.createElement(
                        "span",
                        { className: "score dislikes" },
                        "0 points"
                      ),
                      _react2.default.createElement(
                        "span",
                        { className: "score unvoted" },
                        "0 points"
                      ),
                      _react2.default.createElement(
                        "span",
                        { className: "score likes" },
                        "0 points"
                      ),
                      " |",
                      _react2.default.createElement(
                        "a",
                        { className: "reddit-comment-link may-blank" },
                        "0 comments"
                      )
                    )
                  ),
                  _react2.default.createElement("div", { className: "reddit-link-end" })
                )
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "right" },
              _react2.default.createElement(
                "a",
                null,
                "clear"
              )
            )
          )
        )
      )
    )
  );
};

exports.default = RecentlyViewedLinks;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/RecentlyViewedLinks.js
// module id = 321
// module chunks = 0